/**
 * API configuration — single source of truth for the backend URL.
 *
 * The URL is read ONCE from the REACT_APP_API_URL environment variable at
 * module-load time (i.e. when the bundle first executes).  All service files
 * import API_BASE_URL from here; none of them read process.env directly.
 *
 * Required .env entry:
 *   REACT_APP_API_URL=http://localhost:5036/api/v1
 *
 * The app will throw immediately on startup if the variable is not set,
 * so misconfigured deployments fail loudly rather than silently using a
 * hard-coded localhost address.
 */

// In the Electron desktop app, preload.js exposes window.IMS_API_URL at
// runtime (localhost for the standalone build, the configured server for the
// thin-client build). It takes precedence over the build-time env variable so
// one React build works for web, standalone desktop, and client desktop.
const _runtimeUrl =
  typeof window !== 'undefined' ? (window as { IMS_API_URL?: string }).IMS_API_URL : undefined;

const _url = _runtimeUrl || process.env.REACT_APP_API_URL;

if (!_url) {
  throw new Error(
    '[IMS] REACT_APP_API_URL is not set.\n' +
    'Add it to your .env (or .env.production) file:\n' +
    '  REACT_APP_API_URL=http://<your-api-host>/api/v1'
  );
}

export const API_BASE_URL: string = _url;
